import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux'; // Import useSelector hook
import NavBar from './components/public/NavBar';
import Login from './components/public/Login';
import SignupModal from './components/public/SignUp';
import Dashboards from './components/private/dashboard/Dashboards';
import LoggedInNavBar from './components/private/LoggedInNavBar';
import Grocery from './components/private/highgarden/groceryLists/Grocery';
import CouponOptions from './components/private/astapor/Coupons';
import OfferOptions from './components/private/highgarden/offers/Offers';
import AnalyticsOptions from './components/private/highgarden/analytics/Analytics';
import UserAccount from './components/private/users/UserAccount';
import StandardToastContainer from './components/private/common_components/standardToastContainer';
import UserFavoriteProducts from './components/private/highgarden/favorites/UserFavoriteProducts';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      // Dispatch an action to update state to indicate user is authenticated
      dispatch({ type: 'AUTHENTICATE_USER', payload: token });
    }
  }, [dispatch]);

  const isAuthenticated = useSelector(state => state.auth.isAuthenticated); // Use Redux state to check if user is authenticated

  // A component that conditionally renders NavBar based on authentication status
  const ConditionalNavBar = () => {
    return isAuthenticated ? <LoggedInNavBar /> : <NavBar />;
  };

  return (
    <Router>
      <div className={isAuthenticated ? "app-container" : ""}> {/* This ensures that LoggedInNavBar and the main content area are laid out horizontally side by side. */}
        <ConditionalNavBar />
        <div className="main-content">
          <Row>
            <Col lg={{ span: 12 }}> {/* Adjust 'lg' values as per your layout needs */}
              <Routes>
                <Route path="/signup" element={<SignupModal />} />
                <Route path="/login" element={isAuthenticated ? <Navigate replace to="/dashboard" /> : <Login />} />
                <Route path="/dashboard" element={<PrivateRoute><Dashboards /></PrivateRoute>} />
                <Route path="/astapor/coupons" element={<PrivateRoute><CouponOptions /></PrivateRoute>} />
                <Route path="/highgarden/grocery_lists" element={<PrivateRoute><Grocery /></PrivateRoute>} />
                <Route path="/highgarden/favorites" element={<PrivateRoute><UserFavoriteProducts /></PrivateRoute>} />
                <Route path="/highgarden/offers" element={<PrivateRoute><OfferOptions /></PrivateRoute>} />
                <Route path="/highgarden/analytics" element={<PrivateRoute><AnalyticsOptions /></PrivateRoute>} />
                <Route path="/account" element={<PrivateRoute><UserAccount /></PrivateRoute>} />
                {/* Redirect from root URL to /home. This is optional */}
                <Route path="/" element={<Navigate replace to="/home" />} />
              </Routes>
            </Col>
          </Row>
        </div>
      </div>
      <StandardToastContainer />
    </Router>
  );
}

export default App;
